"use strict";
/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.ContentType = exports.Currencies = exports.MaxSizeAddresses = exports.MaxSizeAddressesForTokens = exports.MaxSizeTokens = exports.PaginationPageDefault = exports.PaginationLimitMax = exports.PaginationLimitDefault = exports.TokenStdInterfaceId = exports.IntervalType = void 0;
/** IntervalType */
var IntervalType;
(function (IntervalType) {
    IntervalType["Daily"] = "daily";
    IntervalType["Hourly"] = "hourly";
    IntervalType["Weekly"] = "weekly";
})(IntervalType = exports.IntervalType || (exports.IntervalType = {}));
/** TokenStdInterfaceId */
var TokenStdInterfaceId;
(function (TokenStdInterfaceId) {
    TokenStdInterfaceId["Fungible"] = "fungible";
    TokenStdInterfaceId["NonFungible"] = "non-fungible";
    TokenStdInterfaceId["NonStandard"] = "non-standard";
})(TokenStdInterfaceId = exports.TokenStdInterfaceId || (exports.TokenStdInterfaceId = {}));
var PaginationLimitDefault;
(function (PaginationLimitDefault) {
    PaginationLimitDefault[PaginationLimitDefault["Value20"] = 20] = "Value20";
    PaginationLimitDefault[PaginationLimitDefault["Value10"] = 10] = "Value10";
})(PaginationLimitDefault = exports.PaginationLimitDefault || (exports.PaginationLimitDefault = {}));
var PaginationLimitMax;
(function (PaginationLimitMax) {
    PaginationLimitMax[PaginationLimitMax["Value100"] = 100] = "Value100";
    PaginationLimitMax[PaginationLimitMax["Value20"] = 20] = "Value20";
})(PaginationLimitMax = exports.PaginationLimitMax || (exports.PaginationLimitMax = {}));
var PaginationPageDefault;
(function (PaginationPageDefault) {
    PaginationPageDefault[PaginationPageDefault["Value1"] = 1] = "Value1";
})(PaginationPageDefault = exports.PaginationPageDefault || (exports.PaginationPageDefault = {}));
var MaxSizeTokens;
(function (MaxSizeTokens) {
    MaxSizeTokens[MaxSizeTokens["Value80"] = 80] = "Value80";
})(MaxSizeTokens = exports.MaxSizeTokens || (exports.MaxSizeTokens = {}));
var MaxSizeAddressesForTokens;
(function (MaxSizeAddressesForTokens) {
    MaxSizeAddressesForTokens[MaxSizeAddressesForTokens["Value80"] = 80] = "Value80";
})(MaxSizeAddressesForTokens = exports.MaxSizeAddressesForTokens || (exports.MaxSizeAddressesForTokens = {}));
var MaxSizeAddresses;
(function (MaxSizeAddresses) {
    MaxSizeAddresses[MaxSizeAddresses["Value80"] = 80] = "Value80";
})(MaxSizeAddresses = exports.MaxSizeAddresses || (exports.MaxSizeAddresses = {}));
var Currencies;
(function (Currencies) {
    Currencies["Btc"] = "btc";
    Currencies["Eth"] = "eth";
    Currencies["Usd"] = "usd";
    Currencies["Eur"] = "eur";
    Currencies["Chf"] = "chf";
    Currencies["Gbp"] = "gbp";
    Currencies["Idr"] = "idr";
    Currencies["Vnd"] = "vnd";
    Currencies["Rub"] = "rub";
    Currencies["Try"] = "try";
    Currencies["Cad"] = "cad";
    Currencies["Aud"] = "aud";
    Currencies["Hkd"] = "hkd";
    Currencies["Thb"] = "thb";
    Currencies["Cny"] = "cny";
})(Currencies = exports.Currencies || (exports.Currencies = {}));
require("cross-fetch/polyfill");
const utils_1 = require("./utils");
var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
class HttpClient {
    constructor(apiConfig = {}) {
        this.baseUrl = '';
        this.securityData = null;
        this.abortControllers = new Map();
        this.customFetch = (...fetchParams) => fetch(...fetchParams);
        this.baseApiParams = {
            credentials: 'same-origin',
            headers: {},
            redirect: 'follow',
            referrerPolicy: 'no-referrer'
        };
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.contentFormatters = {
            [ContentType.Json]: (input) => input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
            [ContentType.Text]: (input) => (input !== null && typeof input !== 'string' ? JSON.stringify(input) : input),
            [ContentType.FormData]: (input) => Object.keys(input || {}).reduce((formData, key) => {
                const property = input[key];
                formData.append(key, property instanceof Blob
                    ? property
                    : typeof property === 'object' && property !== null
                        ? JSON.stringify(property)
                        : `${property}`);
                return formData;
            }, new FormData()),
            [ContentType.UrlEncoded]: (input) => this.toQueryString(input)
        };
        this.createAbortSignal = (cancelToken) => {
            if (this.abortControllers.has(cancelToken)) {
                const abortController = this.abortControllers.get(cancelToken);
                if (abortController) {
                    return abortController.signal;
                }
                return void 0;
            }
            const abortController = new AbortController();
            this.abortControllers.set(cancelToken, abortController);
            return abortController.signal;
        };
        this.abortRequest = (cancelToken) => {
            const abortController = this.abortControllers.get(cancelToken);
            if (abortController) {
                abortController.abort();
                this.abortControllers.delete(cancelToken);
            }
        };
        this.request = async ({ body, secure, path, type, query, format, baseUrl, cancelToken, ...params }) => {
            const secureParams = ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
                this.securityWorker &&
                (await this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const queryString = query && this.toQueryString(query);
            const payloadFormatter = this.contentFormatters[type || ContentType.Json];
            const responseFormat = format || requestParams.format;
            return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
                ...requestParams,
                headers: {
                    ...(requestParams.headers || {}),
                    ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {})
                },
                signal: cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal,
                body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body)
            }).then(async (response) => {
                const r = response;
                r.data = null;
                r.error = null;
                const data = !responseFormat
                    ? r
                    : await response[responseFormat]()
                        .then((data) => {
                        if (r.ok) {
                            r.data = data;
                        }
                        else {
                            r.error = data;
                        }
                        return r;
                    })
                        .catch((e) => {
                        r.error = e;
                        return r;
                    });
                if (cancelToken) {
                    this.abortControllers.delete(cancelToken);
                }
                return data;
            });
        };
        Object.assign(this, apiConfig);
    }
    encodeQueryParam(key, value) {
        const encodedKey = encodeURIComponent(key);
        return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
    }
    addQueryParam(query, key) {
        return this.encodeQueryParam(key, query[key]);
    }
    addArrayQueryParam(query, key) {
        const value = query[key];
        return value.map((v) => this.encodeQueryParam(key, v)).join('&');
    }
    toQueryString(rawQuery) {
        const query = rawQuery || {};
        const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key]);
        return keys
            .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
            .join('&');
    }
    addQueryParams(rawQuery) {
        const queryString = this.toQueryString(rawQuery);
        return queryString ? `?${queryString}` : '';
    }
    mergeRequestParams(params1, params2) {
        return {
            ...this.baseApiParams,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...(this.baseApiParams.headers || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {})
            }
        };
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Alephium Explorer API
 * @version 1.0
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.blocks = {
            /**
             * No description
             *
             * @tags Blocks
             * @name GetBlocks
             * @summary List latest blocks
             * @request GET:/blocks
             */
            getBlocks: (query, params = {}) => this.request({
                path: `/blocks`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Blocks
             * @name GetBlocksBlockHash
             * @summary Get a block with hash
             * @request GET:/blocks/{block_hash}
             */
            getBlocksBlockHash: (blockHash, params = {}) => this.request({
                path: `/blocks/${blockHash}`,
                method: 'GET',
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Blocks
             * @name GetBlocksBlockHashTransactions
             * @summary Get block's transactions
             * @request GET:/blocks/{block_hash}/transactions
             */
            getBlocksBlockHashTransactions: (blockHash, query, params = {}) => this.request({
                path: `/blocks/${blockHash}/transactions`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse)
        };
        this.transactions = {
            /**
             * No description
             *
             * @tags Transactions
             * @name GetTransactionsTransactionHash
             * @summary Get a transaction with hash
             * @request GET:/transactions/{transaction_hash}
             */
            getTransactionsTransactionHash: (transactionHash, params = {}) => this.request({
                path: `/transactions/${transactionHash}`,
                method: 'GET',
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse)
        };
        this.addresses = {
            /**
             * No description
             *
             * @tags Addresses
             * @name GetAddressesAddress
             * @summary Get address information
             * @request GET:/addresses/{address}
             */
            getAddressesAddress: (address, params = {}) => this.request({
                path: `/addresses/${address}`,
                method: 'GET',
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Addresses
             * @name GetAddressesAddressTransactions
             * @summary List transactions of a given address
             * @request GET:/addresses/{address}/transactions
             */
            getAddressesAddressTransactions: (address, query, params = {}) => this.request({
                path: `/addresses/${address}/transactions`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Addresses
             * @name PostAddressesTransactions
             * @summary List transactions for given addresses
             * @request POST:/addresses/transactions
             * @deprecated
             */
            postAddressesTransactions: (query, data, params = {}) => this.request({
                path: `/addresses/transactions`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Addresses
             * @name GetAddressesAddressTimerangedTransactions
             * @summary List transactions of a given address within a time-range
             * @request GET:/addresses/{address}/timeranged-transactions
             */
            getAddressesAddressTimerangedTransactions: (address, query, params = {}) => this.request({
                path: `/addresses/${address}/timeranged-transactions`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Addresses
             * @name GetAddressesAddressTotalTransactions
             * @summary Get total transactions of a given address
             * @request GET:/addresses/{address}/total-transactions
             */
            getAddressesAddressTotalTransactions: (address, params = {}) => this.request({
                path: `/addresses/${address}/total-transactions`,
                method: 'GET',
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Addresses
             * @name GetAddressesAddressLatestTransaction
             * @summary Get latest transaction information of a given address
             * @request GET:/addresses/{address}/latest-transaction
             */
            getAddressesAddressLatestTransaction: (address, params = {}) => this.request({
                path: `/addresses/${address}/latest-transaction`,
                method: 'GET',
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Addresses
             * @name GetAddressesAddressMempoolTransactions
             * @summary List mempool transactions of a given address
             * @request GET:/addresses/{address}/mempool/transactions
             */
            getAddressesAddressMempoolTransactions: (address, params = {}) => this.request({
                path: `/addresses/${address}/mempool/transactions`,
                method: 'GET',
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Addresses
             * @name GetAddressesAddressBalance
             * @summary Get address balance
             * @request GET:/addresses/{address}/balance
             */
            getAddressesAddressBalance: (address, params = {}) => this.request({
                path: `/addresses/${address}/balance`,
                method: 'GET',
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Addresses
             * @name GetAddressesAddressTokens
             * @summary List address tokens
             * @request GET:/addresses/{address}/tokens
             * @deprecated
             */
            getAddressesAddressTokens: (address, query, params = {}) => this.request({
                path: `/addresses/${address}/tokens`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Addresses
             * @name GetAddressesAddressTokensTokenIdTransactions
             * @summary List address tokens
             * @request GET:/addresses/{address}/tokens/{token_id}/transactions
             */
            getAddressesAddressTokensTokenIdTransactions: (address, tokenId, query, params = {}) => this.request({
                path: `/addresses/${address}/tokens/${tokenId}/transactions`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Addresses
             * @name GetAddressesAddressTokensTokenIdBalance
             * @summary Get address balance of given token
             * @request GET:/addresses/{address}/tokens/{token_id}/balance
             */
            getAddressesAddressTokensTokenIdBalance: (address, tokenId, params = {}) => this.request({
                path: `/addresses/${address}/tokens/${tokenId}/balance`,
                method: 'GET',
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Addresses
             * @name GetAddressesAddressPublicKey
             * @summary Use `/addresses/{address}/typed-public-key` instead
             * @request GET:/addresses/{address}/public-key
             * @deprecated
             */
            getAddressesAddressPublicKey: (address, params = {}) => this.request({
                path: `/addresses/${address}/public-key`,
                method: 'GET',
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Addresses
             * @name GetAddressesAddressTokensBalance
             * @summary Get address tokens with balance
             * @request GET:/addresses/{address}/tokens-balance
             */
            getAddressesAddressTokensBalance: (address, query, params = {}) => this.request({
                path: `/addresses/${address}/tokens-balance`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Addresses, Addresses
             * @name PostAddressesUsed
             * @summary Are the addresses used (at least 1 transaction)
             * @request POST:/addresses/used
             */
            postAddressesUsed: (data, params = {}) => this.request({
                path: `/addresses/used`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Addresses
             * @name GetAddressesAddressExportTransactionsCsv
             * @request GET:/addresses/{address}/export-transactions/csv
             */
            getAddressesAddressExportTransactionsCsv: (address, query, params = {}) => this.request({
                path: `/addresses/${address}/export-transactions/csv`,
                method: 'GET',
                query: query,
                format: 'text',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Addresses
             * @name GetAddressesAddressAmountHistory
             * @request GET:/addresses/{address}/amount-history
             * @deprecated
             */
            getAddressesAddressAmountHistory: (address, query, params = {}) => this.request({
                path: `/addresses/${address}/amount-history`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse)
        };
        this.infos = {
            /**
             * No description
             *
             * @tags Infos
             * @name GetInfos
             * @summary Get explorer informations
             * @request GET:/infos
             */
            getInfos: (params = {}) => this.request({
                path: `/infos`,
                method: 'GET',
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Infos
             * @name GetInfosHeights
             * @summary List latest height for each chain
             * @request GET:/infos/heights
             */
            getInfosHeights: (params = {}) => this.request({
                path: `/infos/heights`,
                method: 'GET',
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Infos
             * @name GetInfosSupply
             * @summary Get token supply list
             * @request GET:/infos/supply
             */
            getInfosSupply: (query, params = {}) => this.request({
                path: `/infos/supply`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Infos
             * @name GetInfosSupplyTotalAlph
             * @summary Get the ALPH total supply
             * @request GET:/infos/supply/total-alph
             */
            getInfosSupplyTotalAlph: (params = {}) => this.request({
                path: `/infos/supply/total-alph`,
                method: 'GET',
                format: 'text',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Infos
             * @name GetInfosSupplyCirculatingAlph
             * @summary Get the ALPH circulating supply
             * @request GET:/infos/supply/circulating-alph
             */
            getInfosSupplyCirculatingAlph: (params = {}) => this.request({
                path: `/infos/supply/circulating-alph`,
                method: 'GET',
                format: 'text',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Infos
             * @name GetInfosSupplyReservedAlph
             * @summary Get the ALPH reserved supply
             * @request GET:/infos/supply/reserved-alph
             */
            getInfosSupplyReservedAlph: (params = {}) => this.request({
                path: `/infos/supply/reserved-alph`,
                method: 'GET',
                format: 'text',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Infos
             * @name GetInfosSupplyLockedAlph
             * @summary Get the ALPH locked supply
             * @request GET:/infos/supply/locked-alph
             */
            getInfosSupplyLockedAlph: (params = {}) => this.request({
                path: `/infos/supply/locked-alph`,
                method: 'GET',
                format: 'text',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Infos
             * @name GetInfosTotalTransactions
             * @summary Get the total number of transactions
             * @request GET:/infos/total-transactions
             */
            getInfosTotalTransactions: (params = {}) => this.request({
                path: `/infos/total-transactions`,
                method: 'GET',
                format: 'text',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Infos
             * @name GetInfosAverageBlockTimes
             * @summary Get the average block time for each chain
             * @request GET:/infos/average-block-times
             */
            getInfosAverageBlockTimes: (params = {}) => this.request({
                path: `/infos/average-block-times`,
                method: 'GET',
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse)
        };
        this.mempool = {
            /**
             * No description
             *
             * @tags Mempool
             * @name GetMempoolTransactions
             * @summary list mempool transactions
             * @request GET:/mempool/transactions
             */
            getMempoolTransactions: (query, params = {}) => this.request({
                path: `/mempool/transactions`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse)
        };
        this.tokens = {
            /**
             * No description
             *
             * @tags Tokens
             * @name GetTokens
             * @summary List token information
             * @request GET:/tokens
             */
            getTokens: (query, params = {}) => this.request({
                path: `/tokens`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Tokens
             * @name PostTokens
             * @summary List given tokens information
             * @request POST:/tokens
             */
            postTokens: (data, params = {}) => this.request({
                path: `/tokens`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Tokens
             * @name GetTokensTokenIdTransactions
             * @summary List token transactions
             * @request GET:/tokens/{token_id}/transactions
             */
            getTokensTokenIdTransactions: (tokenId, query, params = {}) => this.request({
                path: `/tokens/${tokenId}/transactions`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Tokens
             * @name GetTokensTokenIdAddresses
             * @summary List token addresses
             * @request GET:/tokens/{token_id}/addresses
             */
            getTokensTokenIdAddresses: (tokenId, query, params = {}) => this.request({
                path: `/tokens/${tokenId}/addresses`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * @description If metadata doesn't exist or token isn't a fungible, it won't be in the output list
             *
             * @tags Tokens
             * @name PostTokensFungibleMetadata
             * @summary Return metadata for the given fungible tokens
             * @request POST:/tokens/fungible-metadata
             */
            postTokensFungibleMetadata: (data, params = {}) => this.request({
                path: `/tokens/fungible-metadata`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * @description If metadata doesn't exist or token isn't a nft, it won't be in the output list
             *
             * @tags Tokens
             * @name PostTokensNftMetadata
             * @summary Return metadata for the given nft tokens
             * @request POST:/tokens/nft-metadata
             */
            postTokensNftMetadata: (data, params = {}) => this.request({
                path: `/tokens/nft-metadata`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * @description If metadata doesn't exist or address isn't a nft collection, it won't be in the output list
             *
             * @tags Tokens
             * @name PostTokensNftCollectionMetadata
             * @summary Return metadata for the given nft collection addresses
             * @request POST:/tokens/nft-collection-metadata
             */
            postTokensNftCollectionMetadata: (data, params = {}) => this.request({
                path: `/tokens/nft-collection-metadata`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * @description Updates once per day.
             *
             * @tags Tokens
             * @name GetTokensHoldersAlph
             * @summary Get a sorted list of top addresses by ALPH balance
             * @request GET:/tokens/holders/alph
             */
            getTokensHoldersAlph: (query, params = {}) => this.request({
                path: `/tokens/holders/alph`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * @description Updates once per day.
             *
             * @tags Tokens
             * @name GetTokensHoldersTokenTokenId
             * @summary Get a sorted list of top addresses by {token_id} balance. Updates once per day.
             * @request GET:/tokens/holders/token/{token_id}
             */
            getTokensHoldersTokenTokenId: (tokenId, query, params = {}) => this.request({
                path: `/tokens/holders/token/${tokenId}`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse)
        };
        this.charts = {
            /**
             * @description `interval-type` query param: hourly, daily
             *
             * @tags Charts
             * @name GetChartsHashrates
             * @summary Get hashrate chart in H/s
             * @request GET:/charts/hashrates
             */
            getChartsHashrates: (query, params = {}) => this.request({
                path: `/charts/hashrates`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * @description `interval-type` query param: hourly, daily
             *
             * @tags Charts
             * @name GetChartsTransactionsCount
             * @summary Get transaction count history
             * @request GET:/charts/transactions-count
             */
            getChartsTransactionsCount: (query, params = {}) => this.request({
                path: `/charts/transactions-count`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * @description `interval-type` query param: hourly, daily
             *
             * @tags Charts
             * @name GetChartsTransactionsCountPerChain
             * @summary Get transaction count history per chain
             * @request GET:/charts/transactions-count-per-chain
             */
            getChartsTransactionsCountPerChain: (query, params = {}) => this.request({
                path: `/charts/transactions-count-per-chain`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse)
        };
        this.contractEvents = {
            /**
             * No description
             *
             * @tags Contract events
             * @name GetContractEventsTransactionIdTransactionId
             * @summary Get contract events by transaction id
             * @request GET:/contract-events/transaction-id/{transaction_id}
             */
            getContractEventsTransactionIdTransactionId: (transactionId, params = {}) => this.request({
                path: `/contract-events/transaction-id/${transactionId}`,
                method: 'GET',
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Contract events
             * @name GetContractEventsContractAddressContractAddress
             * @summary Get contract events by contract address
             * @request GET:/contract-events/contract-address/{contract_address}
             */
            getContractEventsContractAddressContractAddress: (contractAddress, query, params = {}) => this.request({
                path: `/contract-events/contract-address/${contractAddress}`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Contract events
             * @name GetContractEventsContractAddressContractAddressInputAddressInputAddress
             * @summary Get contract events by contract and input addresses
             * @request GET:/contract-events/contract-address/{contract_address}/input-address/{input_address}
             */
            getContractEventsContractAddressContractAddressInputAddressInputAddress: (contractAddress, inputAddress, query, params = {}) => this.request({
                path: `/contract-events/contract-address/${contractAddress}/input-address/${inputAddress}`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse)
        };
        this.contracts = {
            /**
             * No description
             *
             * @tags Contracts
             * @name GetContractsContractAddressCurrentLiveness
             * @summary Get contract liveness
             * @request GET:/contracts/{contract_address}/current-liveness
             */
            getContractsContractAddressCurrentLiveness: (contractAddress, params = {}) => this.request({
                path: `/contracts/${contractAddress}/current-liveness`,
                method: 'GET',
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Contracts
             * @name GetContractsContractAddressParent
             * @summary Get contract parent address if exist
             * @request GET:/contracts/{contract_address}/parent
             */
            getContractsContractAddressParent: (contractAddress, params = {}) => this.request({
                path: `/contracts/${contractAddress}/parent`,
                method: 'GET',
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Contracts
             * @name GetContractsContractAddressSubContracts
             * @summary Get sub contract addresses
             * @request GET:/contracts/{contract_address}/sub-contracts
             */
            getContractsContractAddressSubContracts: (contractAddress, query, params = {}) => this.request({
                path: `/contracts/${contractAddress}/sub-contracts`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse)
        };
        this.market = {
            /**
             * No description
             *
             * @tags Market
             * @name PostMarketPrices
             * @request POST:/market/prices
             */
            postMarketPrices: (query, data, params = {}) => this.request({
                path: `/market/prices`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Market
             * @name GetMarketPricesSymbolCharts
             * @request GET:/market/prices/{symbol}/charts
             */
            getMarketPricesSymbolCharts: (symbol, query, params = {}) => this.request({
                path: `/market/prices/${symbol}/charts`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params
            }).then(utils_1.convertHttpResponse)
        };
        this.utils = {
            /**
             * No description
             *
             * @tags Utils
             * @name PutUtilsSanityCheck
             * @summary Perform a sanity check
             * @request PUT:/utils/sanity-check
             */
            putUtilsSanityCheck: (params = {}) => this.request({
                path: `/utils/sanity-check`,
                method: 'PUT',
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Utils
             * @name PutUtilsUpdateGlobalLoglevel
             * @summary Update global log level, accepted: TRACE, DEBUG, INFO, WARN, ERROR
             * @request PUT:/utils/update-global-loglevel
             */
            putUtilsUpdateGlobalLoglevel: (data, params = {}) => this.request({
                path: `/utils/update-global-loglevel`,
                method: 'PUT',
                body: data,
                ...params
            }).then(utils_1.convertHttpResponse),
            /**
             * No description
             *
             * @tags Utils
             * @name PutUtilsUpdateLogConfig
             * @summary Update logback values
             * @request PUT:/utils/update-log-config
             */
            putUtilsUpdateLogConfig: (data, params = {}) => this.request({
                path: `/utils/update-log-config`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                ...params
            }).then(utils_1.convertHttpResponse)
        };
    }
}
exports.Api = Api;
